export { default } from './Tray';